<template slot-scope="scope">
  <dialogModel
        title="申请退款"
        :visible.sync="VisibleRefund"
        @handleClose="handleClose"
        @handleOk="handleUnderstand"
        width="1100px"
      >
        <div class="dialog-content" v-loading="detailLoading">
          <div class="agent-detail">
            <div class="detail-section agent-info-summary">
              <div class="section-header">
                <span class="section-title">代理企业信息</span>
                <span class="status-tag" :class="statusTagClass">
                  <span class="status-dot"></span>
                  {{ proxyStatusText }}
                </span>
                <span
                  v-if="proxyTimeText && proxyStatusText == '代理中'"
                  class="proxy-time"
                  >{{ proxyTimeText }}</span
                >
              </div>
              <div class="agent-info-summary-grid">
                <div class="summary-cell">
                  <span class="summary-label">企业类型：</span>
                  <span class="summary-value">{{
                    rowObj.orderCompanyTypeName || "-"
                  }}</span>
                </div>
                <div class="summary-cell">
                  <span class="summary-label">纳税类型：</span>
                  <span class="summary-value">{{
                    rowObj.orderTaxTypeName || "-"
                  }}</span>
                </div>
                <div class="summary-cell">
                  <span class="summary-label">企业名称：</span>
                  <span class="summary-value">{{
                    rowObj.orderCompanyName || "-"
                  }}</span>
                </div>
                <div class="summary-cell">
                  <span class="summary-label">统一社会信用代码：</span>
                  <span class="summary-value">{{
                    rowObj.orderCreditCode || "-"
                  }}</span>
                </div>
                <div v-if="rowObj.taxPassword" class="summary-cell summary-cell--pwd">
                  <span class="summary-label">电子税务局密码：</span>
                  <span class="summary-value">
                    {{ showTaxPwd ? rowObj.taxPassword : "********" }}
                    <span class="pwd-link firm-clickable" @click="showTaxPwd = !showTaxPwd"
                      >查看密码</span
                    >
                  </span>
                </div>
              </div>
            </div>

            <div class="service-info-section">
              <div class="service-info-head">
                <span class="section-title">订单信息</span>
                <button
                  type="button"
                  class="service-info-toggle firm-clickable"
                  @click="serviceSectionOpen = !serviceSectionOpen"
                >
                  {{ serviceSectionOpen ? "收起" : "展开" }}
                  <i
                    :class="
                      serviceSectionOpen
                        ? 'el-icon-arrow-up'
                        : 'el-icon-arrow-down'
                    "
                  ></i>
                </button>
              </div>
              <template v-if="serviceSectionOpen">
                
                <div v-loading="serviceLoading" class="service-info-body">
                  <template v-if="paginatedServiceList.length">
                    <div
                      v-for="(item, index) in paginatedServiceList"
                      :key="serviceItemKey(item, index)"
                      class="service-card"
                      :class="{ 'is-expanded': isServiceExpanded(item, index) }"
                    >
                      <div class="service-card-head">
                        <div class="service-card-main">
                          <div class="service-card-title-line">
                            <span class="service-card-title">{{
                              serviceEventSectionTitle(item)
                            }}</span>
                            <span class="service-card-company">{{
                              eventCompanyLine(item)
                            }}</span>
                          </div>
                          <div class="service-card-summary">
                            <div
                              v-for="(pair, pi) in serviceSummaryRowPairs(item)"
                              :key="'p-' + pi"
                              class="service-card-summary-line"
                            >
                              <div
                                v-for="(row, ri) in pair"
                                :key="'s-' + pi + '-' + ri"
                                class="service-card-summary-cell"
                              >
                                <span class="service-card-summary-label">{{
                                  row.label
                                }}</span>
                                <span class="service-card-summary-value">{{
                                  row.value
                                }}</span>
                              </div>
                            </div>
                            <div class="service-card-summary-line service-card-summary-line--full">
                              <div class="service-card-summary-cell">
                                <span class="service-card-summary-label">备注：</span>
                                <span class="service-card-summary-value">{{
                                  item.note || "--"
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <button
                          type="button"
                          class="service-card-more firm-clickable"
                          @click="toggleServiceExpand(item, index)"
                        >
                          {{
                            isServiceExpanded(item, index)
                              ? "收起"
                              : "查看更多信息"
                          }}
                          <i
                            :class="
                              isServiceExpanded(item, index)
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                            "
                          ></i>
                        </button>
                      </div>
                      <div
                        v-show="isServiceExpanded(item, index)"
                        class="service-card-expand"
                      >
                        <div class="service-card-block service-card-enterprise">
                          <div class="service-card-block-title">代理企业信息</div>
                          <div class="service-card-enterprise-grid">
                            <div class="enterprise-grid-cell">
                              <span class="enterprise-grid-label">企业类型：</span>
                              <span class="enterprise-grid-value">{{
                                eventField(item, "orderCompanyTypeName", "companyTypeName") ||
                                eventCompanyTypeText(item)
                              }}</span>
                            </div>
                            <div class="enterprise-grid-cell">
                              <span class="enterprise-grid-label">纳税类型：</span>
                              <span class="enterprise-grid-value">{{
                                eventField(item, "orderTaxTypeName", "taxTypeName") ||
                                eventTaxTypeText(item)
                              }}</span>
                            </div>
                            <div class="enterprise-grid-cell">
                              <span class="enterprise-grid-label">企业名称：</span>
                              <span class="enterprise-grid-value">{{
                                eventField(item, "orderCompanyName", "companyName")
                              }}</span>
                            </div>
                            <div class="enterprise-grid-cell">
                              <span class="enterprise-grid-label">统一社会信用代码：</span>
                              <span class="enterprise-grid-value">{{
                                eventField(
                                  item,
                                  "orderCreditCode",
                                  "creditCode",
                                  "companyCreditCode"
                                )
                              }}</span>
                            </div>
                            <div class="enterprise-grid-cell">
                              <span class="enterprise-grid-label"
                                >法定代表人(负责人)：</span
                              >
                              <span class="enterprise-grid-value">{{
                                eventField(item, "orderCompanyLegalPerson", "legalPerson")
                              }}</span>
                            </div>
                            <div class="enterprise-grid-cell">
                              <span class="enterprise-grid-label">联系电话：</span>
                              <span class="enterprise-grid-value">{{
                                eventField(item, "orderCompanyPhone", "phone", "companyPhone")
                              }}</span>
                            </div>
                            <div class="enterprise-grid-cell enterprise-grid-cell--full">
                              <span class="enterprise-grid-label">地址：</span>
                              <span class="enterprise-grid-value">{{
                                eventField(
                                  item,
                                  "orderCompanyAddress",
                                  "address",
                                  "companyAddress"
                                )
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <div v-else-if="!serviceLoading" class="service-info-empty">
                    暂无服务记录
                  </div>
                </div>
                <div v-if="serviceTotal > 0" class="service-info-pagination">
                  <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page.sync="servicePage"
                    :page-size="servicePageLimit"
                    :total="serviceTotal"
                    @current-change="onServicePageChange"
                  />
                </div>
              </template>
            </div>
            <div class="detail-section refund-extra">
              <div class="section-header">
                <span class="section-title">申请退款</span>
              </div>
              <div class="refund-instruction">(实际退款金额需后台审核)</div>
              <div class="refund-reason-box">
                <span class="summary-label">退款原因：</span>
                <el-input
                  type="textarea"
                  placeholder="请输入退款原因"
                  v-model="textarea"
                  maxlength="1500"
                  show-word-limit
                  resize="none"
                  :autosize="{ minRows: 4 }"
                />
              </div>
            </div>
          </div>
        </div>
      </dialogModel>
</template>

<script>
import * as API from "@/assets/api/Agency/Enterprise.js";

export default {
  props: {
    VisibleRefund: {},
    ProxyBookkeeping: {
      type: Object,
      default: () => ({}),
    },
    distinguish: {},
  },
  data() {
    return {
      rowObj: {},
      showTaxPwd: false,
      serviceList: [],
      detailLoading: false,
      serviceLoading: false,
      serviceSectionOpen: false,
      serviceExpandedKey: null,
      servicePage: 1,
      servicePageLimit: 3,
      textarea: "",
    };
  },
  computed: {
    proxyBookkeeping() {
      return this.ProxyBookkeeping || {};
    },
    orderAmountText() {
      const v = this.proxyBookkeeping.orderAmount;
      if (v === 0 || v === "0") return "0元";
      if (v != null && v !== "") return `${v}元`;
      return "--";
    },
    remarkText() {
      if (this.distinguish == 2) {
        return this.proxyBookkeeping.remark;
      }
      return this.proxyBookkeeping.orderNote;
    },
    proxyTimeDisplay() {
      const p = this.proxyBookkeeping;
      if (this.distinguish == 2) {
        const start = p.startTime ? String(p.startTime).substr(0, 10) : "";
        const end = p.endTime ? String(p.endTime).substr(0, 10) : "";
        return start && end ? `${start} - ${end}` : start || end || "--";
      }
      const start = p.startTime || "";
      const end = p.endTime || "";
      return start && end ? `${start} - ${end}` : start || end || "--";
    },
    proxyStatusText() {
      const status = this.rowObj.proxyStatus;
      if (status == -1) return "未代理";
      if (status == 0) return "代理中";
      if (status == 1) return "待续费";
      if (status != null && status !== "") return "已过期";
      return "-";
    },
    statusTagClass() {
      const status = this.rowObj.proxyStatus;
      if (status === 0) return "status-active";
      if (status === 1) return "status-renew";
      if (status === -1) return "status-inactive";
      return "status-expired";
    },
    proxyTimeText() {
      const start = this.formatProxyMonth(this.rowObj.proxyStartMoon);
      const end = this.formatProxyMonth(this.rowObj.proxyEndMoon);
      if (start && end) return `${start}-${end}`;
      return start || end || "";
    },
    serviceCompanyTitle() {
      return (
        this.rowObj.orderCompanyName ||
        this.proxyBookkeeping.companyName ||
        "-"
      );
    },
    serviceTotal() {
      return this.serviceList.length;
    },
    paginatedServiceList() {
      const start = (this.servicePage - 1) * this.servicePageLimit;
      return this.serviceList.slice(start, start + this.servicePageLimit);
    },
  },
  watch: {
    VisibleRefund(val) {
      if (val) {
        this.loadData();
      } else {
        this.resetState();
        this.textarea = "";
      }
    },
    rowObj: {
      handler() {
        this.showTaxPwd = false;
        this.tryLoadServiceLog();
      },
      deep: true,
    },
  },
  methods: {
    resetState() {
      this.rowObj = {};
      this.serviceList = [];
      this.showTaxPwd = false;
      this.serviceSectionOpen = false;
      this.serviceExpandedKey = null;
      this.servicePage = 1;
    },
    loadData() {
      const p = this.proxyBookkeeping;
      const creditCode = p.creditCode;
      this.rowObj = this.mapProxyBookkeepingToRowObj(p);
      if (!creditCode) {
        this.$tool.PromptBox("warning", "缺少企业信用代码");
        return;
      }
      this.fetchDetail(creditCode);
    },
    mapProxyBookkeepingToRowObj(p) {
      const typeMap = ["有限公司", "个体户", "子公司", "分公司", "其他"];
      return {
        orderCompanyName: p.companyName,
        orderCompanyTypeName:
          typeMap[p.companyType] != null ? typeMap[p.companyType] : "-",
        orderTaxTypeName:
          p.taxType == 0
            ? "小规模纳税人"
            : p.taxType == 1
            ? "一般纳税人"
            : "-",
        orderCreditCode: p.creditCode,
        taxPassword: p.taxPassword,
        proxyStatus: p.proxyStatus,
        startTime: p.startTime,
        endTime: p.endTime,
      };
    },
    fetchDetail(creditCode) {
      this.detailLoading = true;
      API.bookkeepingLatestDetail({ data: { creditCode } })
        .then((res) => {
          if (res.code == 0) {
            this.rowObj = { ...this.rowObj, ...(res.data || {}) };
          }
        })
        .finally(() => {
          this.detailLoading = false;
        });
    },
    tryLoadServiceLog() {
      const code =
        this.rowObj.customerCompanyCreditCode ||
        this.rowObj.orderCreditCode ||
        this.proxyBookkeeping.creditCode ||
        "";
      if (!code) {
        this.serviceList = [];
        return;
      }
      this.fetchServiceLog(code);
    },
    fetchServiceLog(creditCode) {
      this.serviceLoading = true;
      this.servicePage = 1;
      this.serviceExpandedKey = null;
      API.bookkeepingServiceLog({ data: creditCode })
        .then((res) => {
          if (res.code == 0) {
            this.serviceList = Array.isArray(res.data)
              ? res.data
              : this.normalizeLogList(res.data);
          } else {
            this.serviceList = [];
          }
        })
        .finally(() => {
          this.serviceLoading = false;
        });
    },
    normalizeLogList(data) {
      if (!data) return [];
      if (Array.isArray(data)) return data;
      if (typeof data === "string") {
        try {
          const parsed = JSON.parse(data);
          return Array.isArray(parsed) ? parsed : [];
        } catch (e) {
          return [];
        }
      }
      if (data.list && Array.isArray(data.list)) return data.list;
      return [];
    },
    onServicePageChange(page) {
      this.servicePage = page;
      this.serviceExpandedKey = null;
    },
    serviceItemKey(item, index) {
      if (item.id != null && item.id !== "") return item.id;
      return `svc-${index}-${item.eventTime || ""}`;
    },
    isServiceExpanded(item, index) {
      return this.serviceExpandedKey === this.serviceItemKey(item, index);
    },
    toggleServiceExpand(item, index) {
      const key = this.serviceItemKey(item, index);
      this.serviceExpandedKey = this.serviceExpandedKey === key ? null : key;
    },
    serviceEventSectionTitle(item) {
      const tax = item.taxType == 0 ? "小规模纳税人" : "一般纳税人";
      const y =
        item.monthCount != null && item.monthCount !== ""
          ? `${item.monthCount}个月`
          : item.durationYear != null && item.durationYear !== ""
          ? `${item.durationYear}年`
          : item.timeNum != null && item.timeNum !== ""
          ? `${item.timeNum}年`
          : item.buyYear != null && item.buyYear !== ""
          ? `${item.buyYear}年`
          : "";
      const base =
        item.eventType == 0
          ? `购买${y}`
          : item.eventType == 1
          ? `续费${y}`
          : item.eventType == 2
          ? `升级${y}`
          : item.eventType == 3
          ? "服务停止"
          : "申请退款";
      return `${base}（${tax}）`;
    },
    eventCompanyLine(item) {
      const name =
        item.buyCompanyName ||
        item.orderCompanyName ||
        this.rowObj.buyCompanyName ||
        this.rowObj.orderCompanyName ||
        "-";
      const code =
        item.buyCompanyCreditCode ||
        item.orderCreditCode ||
        this.rowObj.buyCompanyCreditCode ||
        this.rowObj.orderCreditCode ||
        "";
      return code ? `${name}（${code}）` : name;
    },
    eventField(item, ...keys) {
      for (let i = 0; i < keys.length; i++) {
        const v = item[keys[i]];
        if (v != null && v !== "") return v;
      }
      const r = this.rowObj;
      for (let j = 0; j < keys.length; j++) {
        const v2 = r[keys[j]];
        if (v2 != null && v2 !== "") return v2;
      }
      return "-";
    },
    eventCompanyTypeText(item) {
      const t =
        item.orderCompanyType != null
          ? item.orderCompanyType
          : item.companyType != null
          ? item.companyType
          : null;
      if (t == null) return "-";
      const map = ["有限公司", "个体户", "子公司", "分公司", "其他"];
      return map[t] != null ? map[t] : "-";
    },
    eventTaxTypeText(item) {
      if (item.taxType == null) return this.rowObj.orderTaxTypeName || "-";
      return item.taxType == 0 ? "小规模纳税人" : "一般纳税人";
    },
    serviceSummaryRows(item) {
      const rows = [];
      if (item.eventType == 3) {
        rows.push({ label: "停止时间：", value: item.eventTime || "-" });
      } else if (item.eventType == 4) {
        rows.push({
          label: "退款金额：",
          value: this.formatEventAmountYuan(item.eventAmount),
        });
        rows.push({ label: "退款时间：", value: item.eventTime || "-" });
      } else {
        rows.push({
          label: "付款：",
          value: this.formatEventAmountYuan(item.eventAmount),
        });
        rows.push({ label: "付款时间：", value: item.eventTime || "-" });
        if (item.eventType == 0 || item.eventType == 1 || item.eventType == 2) {
          rows.push({
            label: "代理月份变更：",
            value: this.serviceProxyMonthChangeLine(item),
          });
          rows.push({
            label: "服务时间变更：",
            value: this.serviceTimeChangeLine(item),
          });
        }
      }
      return rows;
    },
    serviceSummaryRowPairs(item) {
      const rows = this.serviceSummaryRows(item);
      const pairs = [];
      for (let i = 0; i < rows.length; i += 2) {
        pairs.push(rows.slice(i, i + 2));
      }
      return pairs;
    },
    formatEventAmountYuan(amount) {
      if (amount === 0 || amount === "0") return "0元";
      if (amount != null && amount !== "") return `${amount}元`;
      return "-";
    },
    formatProxyMonthPart(v) {
      if (v == null || v === "") return "";
      const s = String(v);
      return s.includes("月") ? s : `${s}月`;
    },
    serviceProxyMonthChangeLine(item) {
      const a = this.formatProxyMonthPart(item.proxyTimeStartMonth);
      const b = this.formatProxyMonthPart(item.proxyTimeEndMonth);
      if (a && b) return `${a} - ${b}`;
      return a || b || "-";
    },
    serviceTimeChangeLine(item) {
      const s = item.serviceTimeStart;
      const e = item.serviceTimeEnd;
      if (s && e) return `${s} - ${e}`;
      return s || e || "-";
    },
    formatProxyMonth(time) {
      if (!time) return "";
      const str = String(time);
      const match = str.match(/(\d{4})[-/年.](\d{1,2})/);
      if (match) {
        return `${match[1]}年${parseInt(match[2], 10)}月`;
      }
      return str;
    },
    handleClose() {
      this.$emit("handleCloseVisibleRefund");
    },
    handleUnderstand() {
      this.$emit("handleUnVisibleRefund", this.textarea);
    },
  },
};
</script>

<style scoped lang="less">
@detail-navy: #1a3270;
@label-color: #909399;
@value-color: #303133;
@detail-gap: 24px;
@detail-row-gap: 16px;

/deep/.details-dialog .el-dialog {
  width: 960px !important;
  max-width: 96vw;
}

.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
      cursor: pointer;
    }
  }
  div {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}


.agent-detail {
  display: flex;
  flex-direction: column;
  gap: @detail-gap;
  font-size: 14px;
  color: @value-color;
  margin: 0 10%;
}

.agent-info-summary-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 32px;
}

.summary-cell {
  flex: 0 0 calc(50% - 16px);
  min-width: 200px;
  line-height: 22px;
  font-size: 14px;
}

.summary-cell--pwd {
  flex: 0 0 100%;
}

.summary-label {
  color: @label-color;
}

.summary-value {
  color: @value-color;
  word-break: break-all;
}

.pwd-link {
  margin-left: 12px;
  color: #409eff ;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}

.detail-section {
  margin: 0;
}

.section-header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: @detail-row-gap;
  gap: 10px 12px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: @value-color;
}

.status-tag {
  display: inline-flex;
  align-items: center;
  height: 24px;
  padding: 0 10px;
  font-size: 12px;
  border-radius: 12px;
  background: #e8eef8;
  color: @detail-navy;

  .status-dot {
    width: 6px;
    height: 6px;
    margin-right: 6px;
    border-radius: 50%;
    background: @detail-navy;
  }

  &.status-renew {
    background: #fdf6ec;
    color: #e6a23c;
    .status-dot {
      background: #e6a23c;
    }
  }

  &.status-expired {
    background: #f4f4f5;
    color: #909399;
    .status-dot {
      background: #909399;
    }
  }

  &.status-inactive {
    background: #fef0f0;
    color: #f56c6c;
    .status-dot {
      background: #f56c6c;
    }
  }
}

.proxy-time {
  font-size: 14px;
  color: @detail-navy;
}

.refund-extra {
  padding-top: 8px;
  border-top: 1px solid #e9e9ed;
}

.refund-amount {
  font-weight: 600;
}

.refund-instruction {
  margin: 8px 0 12px;
  font-size: 12px;
  color: #999999;
  line-height: 20px;
}

.refund-reason-box {
  display: flex;
  flex-direction: column;
  gap: 8px;

  .summary-label {
    color: @label-color;
    font-size: 14px;
  }
}

/deep/.refund-reason-box .el-textarea {
  width: 100%;
}

/deep/.refund-reason-box .el-textarea__inner {
  min-height: 100px !important;
  border-radius: 2px;
  border: 1px solid #e9e9ed !important;
}

/deep/.refund-reason-box .el-input__count {
  bottom: -20px !important;
}

/deep/.el-dialog__footer {
  text-align: center;
  padding-top: 10px;
}

.service-info-section {
  margin-top: 8px;
}

.service-info-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.service-info-toggle {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  font-size: 13px;
  color: #fff;
  background: @detail-navy;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.service-info-company {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 16px;
  color: @value-color;
}

.service-info-body {
  min-height: 40px;
}

.service-card {
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  background: #f7f8fa;
  margin-bottom: 16px;
  padding: 16px 18px;
  transition: border-color 0.2s, background 0.2s;

  &.is-expanded {
    background: #fff;
    border-color: #409eff ;
    box-shadow: 0 0 0 1px rgba(97, 144, 232, 0.15);
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.service-card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.service-card-main {
  flex: 1;
  min-width: 0;
}

.service-card-title-line {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 4px 16px;
  margin-bottom: 10px;
}

.service-card-title-line .service-card-title {
  flex-shrink: 0;
}

.service-card-title {
  font-weight: 600;
  font-size: 14px;
  color: @value-color;
}

.service-card-company {
  color: #409eff ;
  font-size: 14px;
  word-break: normal;
  overflow-wrap: break-word;
}

.service-card-summary {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.service-card-summary-line {
  display: flex;
  align-items: baseline;
  gap: 24px;
}

.service-card-summary-cell {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: baseline;
  font-size: 14px;
  line-height: 24px;
  gap: 4px;
}

.service-card-summary-line--full .service-card-summary-cell {
  flex: 1 1 100%;
}

.service-card-summary-label {
  flex-shrink: 0;
  color: @label-color;
  white-space: nowrap;
}

.service-card-summary-value {
  flex: 1;
  min-width: 0;
  color: @value-color;
  word-break: normal;
  overflow-wrap: break-word;
  white-space: normal;
}

.service-card-more {
  flex-shrink: 0;
  width: 112px;
  border: none;
  background: transparent;
  color: #409eff ;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
  line-height: 22px;
  white-space: nowrap;
  text-align: right;

  i {
    margin-left: 2px;
  }
}

.service-card-expand {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #e4e7ed;
}

.service-card-block {
  padding: 16px;
  background: #f8fafc;
  border-radius: 4px;
}

.service-card-block-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 14px;
  color: @value-color;
}

.service-card-enterprise-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
}

.enterprise-grid-cell {
  flex: 0 0 calc(50% - 12px);
  min-width: 180px;
  line-height: 22px;
  font-size: 14px;
}

.enterprise-grid-cell--full {
  flex: 0 0 100%;
}

.enterprise-grid-label {
  color: @label-color;
}

.enterprise-grid-value {
  color: @value-color;
  word-break: normal;
  overflow-wrap: break-word;
}

.service-info-empty {
  text-align: center;
  color: @label-color;
  padding: 24px 0;
}

.service-info-pagination {
  margin-top: 20px;
  padding-top: 8px;
  display: flex;
  justify-content: center;

  /deep/.el-pagination {
    .el-pager li.active {
      background: rgba(97, 144, 232, 0.5) !important;
      border: 1px solid #409eff ;
    }
  }
}
</style>
